import { useIndexedByWritingType } from "src/app/hooks";
import useIndexedTableGrid from "./useIndexedTableGrid";
import { SimpleTable } from "src/app/components";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";

const IndexedTableByWritingTypeContainer = ({
    moneySiteId,
    siteOption,
}: {
    moneySiteId?: number;
    siteOption?: SimpleFormSelectOption;
}) => {
    const { indexedByWritingType } = useIndexedByWritingType(moneySiteId);
    const gridColumns = useIndexedTableGrid(siteOption?.label);

    return <SimpleTable gridColumns={gridColumns} rowData={indexedByWritingType} />;
};

export default IndexedTableByWritingTypeContainer;
